/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConfigurazioneMailDTO } from './configurazione-mail-dto';
import { PagoPaConfigDTO } from './pago-pa-config-dto';
import { ConfigurazioneSmsDTO } from './configurazione-sms-dto';
import { TipologiaComune } from './tipologia-comune';


export interface ComuneAdminDTO { 
    id?: string;
    nome?: string;
    slug?: string;
    prefisso_comune?: string;
    codice_fiscale?: string;
    email?: string;
    url_logo_comune?: string;
    url_comune?: string;
    tipologia?: TipologiaComune;
    enabled?: boolean;
    comune_nascosto?: boolean;
    configurazione_mail?: ConfigurazioneMailDTO;
    configurazione_sms?: ConfigurazioneSmsDTO;
    pago_pa_config?: PagoPaConfigDTO;
    referente_status?: ComuneAdminDTOReferenteStatusEnum;
    referente_user_id?: string;
}
export enum ComuneAdminDTOReferenteStatusEnum {
    CREATED = 'CREATED',
    ASSOCIATED = 'ASSOCIATED',
    NONE = 'NONE'
};



